<template>

  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
        <calendar></calendar>
    </div>
  </div>
</template>

<script>
import Calendar from '../Calendar'
export default {
  components: { Calendar },
  data () {
    return {
      columns: [
        {
          text: 'Code',
          value: 'code'
        },
        {
          text: 'Sub Code',
          value: 'sub_code'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Maximum Guests',
          value: 'capacity'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  methods: {
    viewUser: function (publicId) {
      this.$router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: publicId
        }
      })
    }
  }
}
</script>

<style>

</style>
